import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Components
import Icon from '@/assets/icons'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

const AllEmpty = () => {
  const { t } = useTranslation()

  return (
    <div className={cx('empty')}>
      <div className={cx('empty__image')}>
        <Icon.AllEmpty />
      </div>
      <p className={cx('empty__title')}>{t('All_Empty_Title')}</p>
      <p className={cx('empty__description')}>{t('All_Empty_Description')}</p>
    </div>
  )
}

export default AllEmpty
